<template>
  <a class="layout-topbar-action p-ripple p-0 m-0" @click="onTopbarItemClick($event, 'weather')" v-ripple @dblclick="this.$router.push('/view/weather');" v-if="!isLoading && mode === 'topbar'">
  <div class="hidden sm:flex weatherBoxi">
      <div class="flex align-content-center flex-wrap" style="min-height: 50px">
        <div class="flex align-items-center justify-content-center mr-2">
          <ul>
            <li><i :class="`fi ${getModuleValue('OUT_AT').icon} icon-inline text-base mr-1 fg-amber`"></i>{{ getModuleValue('OUT_AT').value }}<span class="text-xs unit">{{ getModuleValue('OUT_AT').unit }}</span></li>
            <li><i :class="`fi ${getModuleValue('OUT_RADIATION').icon} icon-inline text-base mr-1 fg-amber`"></i>{{ getModuleValue('OUT_RADIATION').value }}<span class="text-xs unit">{{ getModuleValue('OUT_RADIATION').unit }}</span></li>
          </ul>
        </div>
        <div class="flex align-items-center justify-content-center ml-2 mr-2">
          <ul>
            <li><i :class="`fi ${getModuleValue('OUT_WindSpeedRaw').icon} icon-inline text-base mr-1 fg-amber`"></i>{{ getModuleValue('OUT_WindSpeedRaw').value }}<span class="text-xs unit">{{ getModuleValue('OUT_WindSpeedRaw').unit }}</span></li>
            <li><i :class="`fi ${getModuleValue('OUT_WindDirectionRawTxt').icon} icon-inline text-base mr-1 fg-amber`"></i>{{ getModuleValue('OUT_WindDirectionRawTxt').value }}</li>
          </ul>
        </div>
        <div class="flex align-items-center justify-content-center ml-2">
          <i :class="`${weatherIcon} icon-inline fs-xlarge mr-1`"></i>
        </div>
      </div>
    </div>
  </a>

  <transition name="layout-topbar-action-panel" v-if="!isLoading && mode === 'topbar'">
    <div class="grid grid-nogutter layout-topbar-action-panel shadow-6 view-lg" v-show="topbarItem === 'weather'">
        <div class="layout-topbar-action-item col-12 md:col-3">
          <widgetGauge :value="getModuleValue('OUT_WindSpeed')" :label="getModuleValue('OUT_WindSpeed').label" :min="0" :max="50" size="150px"/>
        </div>
        <div class="layout-topbar-action-item col-12 md:col-3">
            <widgetWindDirection :value="getModuleValue('OUT_WindDirection')" :label="getModuleValue('OUT_WindDirectionTxt').value" size="150px"/>
        </div>
        <div class="layout-topbar-action-item col-12 md:col-3">
          <widgetGauge :value="getModuleValue('OUT_WindSpeedRaw')" :label="getModuleValue('OUT_WindSpeedRaw').label" :min="0" :max="50" size="150px"/>
        </div>
        <div class="layout-topbar-action-item col-12 md:col-3">
            <widgetWindDirection :value="getModuleValue('OUT_WindDirectionFilter')" :label="getModuleValue('OUT_WindDirectionRawTxt').value" size="150px"/>
        </div>
        <div class="layout-topbar-action-item col-12 md:col-3">
            <widgetGauge :value="getModuleValue('OUT_AT')" :label="getModuleValue('OUT_AT').label" :min="getModuleValue('OUT_24hTemp_Min').value" :max="getModuleValue('OUT_24hTemp_Max').value" size="150px"/>
        </div>
        <div class="layout-topbar-action-item col-12 md:col-3">
            <widgetGauge :value="getModuleValue('OUT_RH')" :label="getModuleValue('OUT_RH').label" :min="0" :max="100" size="150px"/>
        </div>
        <div class="layout-topbar-action-item col-12 md:col-3">
            <widgetGauge :value="getModuleValue('OUT_RainAmount')" :label="getModuleValue('OUT_RainAmount').label" :min="0" :max="100" size="150px" />
        </div>
        <div class="layout-topbar-action-item col-12 md:col-3">
            <widgetGauge :value="getModuleValue('OUT_RADIATION')" :label="getModuleValue('OUT_RADIATION').label" :min="0" :max="1500" size="150px"/>
        </div>
        <div class="layout-topbar-action-item col-12 md:col-3">
            <widgetGauge :value="getModuleValue('OUT_RadiationAmount')" :label="getModuleValue('OUT_RadiationAmount').label" :min="0" :max="100" size="150px"/>
        </div>
        <div class="layout-topbar-action-item col-12 md:col-3">
            <widgetGauge :value="getModuleValue('OUT_Energie')" :label="getModuleValue('OUT_Energie').label" :min="0" :max="getModuleValue('OUT_EnergieGestern').value" size="150px"/>
        </div>
        <div class="layout-topbar-action-item col-12 md:col-3">
            <widgetGauge :value="getModuleValue('OUT_ThermalEnergyNet')" :label="getModuleValue('OUT_ThermalEnergyNet').label" :min="-250" :max="250" size="150px" />
        </div>
        <div class="layout-topbar-action-item col-12 md:col-3">
            <widgetGauge :value="getModuleValue('OUT_Pyrgeometer')" :label="getModuleValue('OUT_Pyrgeometer').label" :min="-250" :max="250" size="150px" />
        </div>
    </div>
  </transition>
</template>


<script>
import { defineComponent } from "vue";
import { mapGetters, mapActions } from 'vuex';
import SocketioService from '@/services/socketioService.js';
import widgetWindDirection from '@/components/fragments/widgetWindDirection.vue';
import widgetGauge from '@/components/fragments/widgetGauge.vue';
// import dialogChartSingle from '@/components/dialog/chartSingle.vue';

export default defineComponent({
  name: "widgetWeatherStats",
  setup() {},
  components: {
    widgetWindDirection,
    widgetGauge,
    // dialogChartSingle,
  },
  emits: ['topbarItemClick'],
  props: {
    topbarItem: String,
    mode: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false
    },
    icon: {
      type: String,
      required: false
    },
    colorActive: {
      type: String,
      required: false
    },
    colorInactive: {
      type: String,
      required: false
    },
    colorText: {
      type: String,
      required: false
    },
  },
  data() {
    return {
      loading: false,
      showChart1: false,
      moduleData: {
        source: {
          server: null,
          identifier: null
        }
      },
    }
  },
  watch: {

  },
  computed: {
    iconLabel: function () {
      if (this.label !== undefined) return this.label;
      if (this.value.label !== undefined) return this.value.label;
      return '';
    },
    iconSymbol: function () {
      if (this.icon !== undefined) return this.icon;
      else return this.value.icon;
    },
    colorSymbol() {
      if (this.value.value) {
        if (this.colorActive !== undefined) return this.colorActive;
        else return `fg-lightGreen`;
      } else {
        if (this.colorInactive !== undefined) return this.colorInactive;
        else return `fg-darkGray`;
      }
    },
    colorTextLabel() {
      if (this.colorText !== undefined) return this.colorText;
      else return `fg-gray`;
    },
    isRecord() {
      if (typeof(this.value) === "object") {
        if (this.value.record === "true") return true;
      }
      return false;
    },
    showPointer() {
      if (this.isRecord) return "cursor-pointer";
      else return "";
    },
    ...mapGetters({
        editMode: 'getEditMode',
        getNodeWidget: 'getNodeWidget',
        getOneDepartment: 'types/getOneDepartment',
        getOneCategory: 'types/getOneCategory',
        getStyleColors: 'getStyleColors',
        getStylePatterns: 'getStylePatterns',
        getModules: 'opcua/getModules',
        getModule: 'opcua/getModule',
        getNode: 'opcua/getNode',
        getModuleFetched: 'opcua/getModuleFetched',
        getSynoptoCode: 'types/getSynoptoCode',
        isMaster: 'auth/isMaster',
        getOpcuaServers: 'opcua/getServers',
    }),
    isLoading: function() {
        if (!this.getModuleFetched(this.moduleHash) || this.loading) return true;
        return false;
    },
    
    connectedModule: function () {
        return "weatherStation";
    },
    moduleHash: function () {
        return `*@*.weatherStation`;
    },
    weatherIcon: function () {
      let icon, color;
      if (this.getModuleValue('OUT_Sturm').value === true) {
        icon = `fi-rr-wind-warning`;
        color = `fg-orange`;
      } else if (this.getModuleValue('OUT_Frost').value === true) {
        icon = `fi-rr-temperature-frigid`;
        color = `fg-lightTeal`;
      } else if (this.getModuleValue('OUT_Regen').value === true) {
        icon = `fi-rr-cloud-showers`;
        color = `fg-blue`;
      } else if (this.getModuleValue('OUT_Nebel').value === true) {
        icon = `fi-rr-fog`;
        color = `fg-lightOlive`;
      } else if (this.getModuleValue('OUT_RADIATION').value < 10) {
        icon = `fi-rr-moon-stars`;
        color = `fg-lightGray`;
      } else if (this.getModuleValue('OUT_RADIATION').value < 400) {
        icon = `fi-rr-clouds-sun`;
        color = `fg-lightAmber`;
      } else if (this.getModuleValue('OUT_RADIATION').value >= 400) {
        icon = `fi-rr-sun`;
        color = `fg-lightYellow`;
      } else {
        icon = `fi-rr-sun`;
        color = `fg-lightGray`;
      }
      return `fi ${icon} ${color}`;
    },
  },
  mounted() {
    // this.checkEditMode();
      if (!this.getModuleFetched(this.moduleHash)) {
          this.loadModule(this.connectedModule).then((module) => {
              const moduleHash = `${module.source.server}@${module.source.identifier}.*`;
              this.moduleData.source.server = module.source.server;
              this.moduleData.source.identifier = module.source.identifier;
              SocketioService.getRedisNodesParam(moduleHash, (err, response) => {
                  if (!err && response) {
                      if (Array.isArray(response) && response.length > 0) {
                          this.setNodesFull(response);
                      }
                  }
              }).then(() => { 
                  if (this.editMode) console.log(`[ENATWIDGET] ${this.moduleHash} : component ready!`);
                  this.setModuleFetched(this.moduleHash);
                  this.loading = false;
              });
          });
      } else {
          this.loading = false;
      }
  },
  methods: {
    ...mapActions({
        loadNode: 'opcua/loadNode',
        loadModule: 'opcua/loadModule',
        setNodesFull: 'opcua/setNodesFull',
        setModuleFetched: 'opcua/setModuleFetched',
    }),
    loadingState(state) {
        if (state) {
            this.loading = true;
        } else {
            this.loading = false;
        }
    },
    checkEditMode() {
        if (this.$store.getters.getPageData.editMode) {
            this.items = [...this.items1, ...this.items2];
        } else {
            this.items = [...this.items1];
        }
    },
    getModuleValue(schemeEntry) {
        // const key = `${this.moduleHash}.${schemeEntry}`;
        const key = `${this.moduleData.source.server}@${this.moduleData.source.identifier}.${schemeEntry}`;
        return this.getNode(key);
    },
    getModuleValueStr(schemeEntry) {
      const key = `${this.moduleData.source.server}@${this.moduleData.source.identifier}.${schemeEntry}`;
      const node = this.getNode(key);
      if (typeof node.unit === 'string' && node.unit.length > 0) {
          return `${node.value}${node.unit}`;
      }
      return `${node.value}`;
        },
    showChart(value) {
      if (this.isRecord) {
        if (value === 'value1') this.showChart1 = true;
      }
    },
    onTopbarItemClick(event, item) {
        this.$emit('topbarItemClick', { originalEvent: event, item: item });
    },
  },
});
</script>

<style lang="scss" scoped>
.weatherBoxi {
  width: 100%;
  height: 100%;
}
.view-sm {
  width: 320px;
}
.view-lg {
  width: 800px;
}
</style>